import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DB from '../../../DAL/DB';
import { useDBSubscribe } from '../../../effects';
import { TYPES } from '../../reducer';

const calendars = new DB.Calendars();

export default function getCalendar() {
  const dispatch = useDispatch();
  const inspectorId = useSelector(state => state.inspector?.id);

  // Guard: if no inspector selected, we might want to skip or pass empty filter
  // Assuming subscription handles undefined nicely or returns empty
  const filterVal = inspectorId || 'NO_ID'; 

  const entries = useDBSubscribe(calendars, { 
    filters: [[`data.inspection.inspector.id`, '==', filterVal]] 
  });
  
  const entriesMap = {};
  for (let e of entries) {
    entriesMap[e.id] = e;
  }

  const changed = [...new Set(Object.keys(entriesMap)), inspectorId].join(',');

  useEffect(
    function () {
      if (!inspectorId) return;

      dispatch({ 
        type: TYPES.CALENDAR, 
        payload: entriesMap 
      });
    },
    [changed, dispatch, inspectorId]
  );
}